'use strict';

var positive700 = "rgba(40, 129, 87, 1)";
var positive500 = "rgba(68, 197, 137, 1)";
var positive300 = "rgba(208, 240, 225, 1)";
var positive100 = "rgba(243, 251, 248, 1)";
var notice900 = "rgba(153, 107, 0, 1)";
var notice700 = "rgba(255, 177, 0, 1)";
var notice300 = "rgba(255, 239, 204, 1)";
var notice100 = "rgba(255, 247, 227, 1)";
var negative700 = "rgba(224, 0, 56, 1)";
var negative300 = "rgba(255, 219, 228, 1)";
var negative100 = "rgba(255, 245, 248, 1)";
var informative700 = "rgba(0, 120, 153, 1)";
var informative100 = "rgba(220, 244, 250, 1)";
var maybeBlue900 = "rgba(0, 81, 102, 1)";
var maybeBlue700 = "rgba(0, 128, 163, 1)";
var maybeBlue500 = "rgba(0, 173, 219, 1)";
var maybeBlue300 = "rgba(168, 237, 255, 1)";
var maybeBlue100 = "rgba(220, 244, 250, 1)";
var yellove900 = "rgba(153, 107, 0, 1)";
var yellove700 = "rgba(255, 177, 0, 1)";
var yellove500 = "rgba(255, 208, 102, 1)";
var yellove300 = "rgba(255, 239, 204, 1)";
var yellove100 = "rgba(255, 247, 227, 1)";
var redio900 = "rgba(102, 0, 26, 1)";
var redio700 = "rgba(235, 0, 59, 1)";
var redio500 = "rgba(255, 51, 102, 1)";
var redio300 = "rgba(255, 153, 179, 1)";
var redio100 = "rgba(255, 245, 248, 1)";
var base900 = "rgba(0, 28, 36, 1)";
var base800 = "rgba(5, 37, 46, 1)";
var base700 = "rgba(24, 50, 57, 1)";
var base600 = "rgba(63, 88, 95, 1)";
var base500 = "rgba(106, 124, 129, 1)";
var base400 = "rgba(149, 160, 163, 1)";
var base300 = "rgba(190, 196, 198, 1)";
var base200 = "rgba(230, 233, 234, 1)";
var base100 = "rgba(247, 248, 248, 1)";
var base0 = "rgba(255, 255, 255, 1)";
var staticDarkPositive700 = "rgba(68, 197, 137, 1)";
var staticDarkPositive500 = "rgba(68, 197, 137, 1)";
var staticDarkPositive300 = "rgba(27, 95, 76, 1)";
var staticDarkPositive100 = "rgba(16, 53, 51, 1)";
var staticDarkNotice900 = "rgba(255, 177, 0, 1)";
var staticDarkNotice700 = "rgba(255, 208, 102, 1)";
var staticDarkNotice300 = "rgba(102, 100, 62, 1)";
var staticDarkNotice100 = "rgba(20, 42, 41, 1)";
var staticDarkNegative700 = "rgba(255, 51, 102, 1)";
var staticDarkNegative300 = "rgba(128, 39, 68, 1)";
var staticDarkNegative100 = "rgba(35, 31, 45, 1)";
var staticDarkInformative700 = "rgba(0, 173, 219, 1)";
var staticDarkInformative100 = "rgba(0, 44, 56, 1)";
var staticPositive700 = "rgba(41, 133, 90, 1)";
var staticPositive500 = "rgba(68, 197, 137, 1)";
var staticPositive300 = "rgba(208, 240, 225, 1)";
var staticPositive100 = "rgba(243, 251, 248, 1)";
var staticNotice900 = "rgba(153, 107, 0, 1)";
var staticNotice700 = "rgba(255, 177, 0, 1)";
var staticNotice300 = "rgba(255, 239, 204, 1)";
var staticNotice100 = "rgba(255, 247, 227, 1)";
var staticNegative700 = "rgba(235, 0, 59, 1)";
var staticNegative300 = "rgba(255, 219, 228, 1)";
var staticNegative100 = "rgba(255, 245, 248, 1)";
var staticInformative700 = "rgba(0, 128, 163, 1)";
var staticInformative100 = "rgba(245, 253, 255, 1)";
var staticDarkMaybeBlue900 = "rgba(230, 233, 234, 1)";
var staticDarkMaybeBlue700 = "rgba(190, 196, 198, 1)";
var staticDarkMaybeBlue500 = "rgba(149, 160, 163, 1)";
var staticDarkMaybeBlue300 = "rgba(63, 88, 95, 1)";
var staticDarkMaybeBlue100 = "rgba(24, 50, 57, 1)";
var staticDarkYellove900 = "rgba(230, 233, 234, 1)";
var staticDarkYellove700 = "rgba(190, 196, 198, 1)";
var staticDarkYellove500 = "rgba(149, 160, 163, 1)";
var staticDarkYellove300 = "rgba(63, 88, 95, 1)";
var staticDarkYellove100 = "rgba(24, 50, 57, 1)";
var staticDarkRedio900 = "rgba(230, 233, 234, 1)";
var staticDarkRedio700 = "rgba(190, 196, 198, 1)";
var staticDarkRedio500 = "rgba(149, 160, 163, 1)";
var staticDarkRedio300 = "rgba(63, 88, 95, 1)";
var staticDarkRedio100 = "rgba(24, 50, 57, 1)";
var staticMaybeBlue900 = "rgba(0, 81, 102, 1)";
var staticMaybeBlue700 = "rgba(0, 128, 163, 1)";
var staticMaybeBlue500 = "rgba(0, 173, 219, 1)";
var staticMaybeBlue300 = "rgba(168, 237, 255, 1)";
var staticMaybeBlue100 = "rgba(220, 244, 250, 1)";
var staticYellove900 = "rgba(153, 107, 0, 1)";
var staticYellove700 = "rgba(255, 177, 0, 1)";
var staticYellove500 = "rgba(255, 208, 102, 1)";
var staticYellove300 = "rgba(255, 239, 204, 1)";
var staticYellove100 = "rgba(255, 247, 227, 1)";
var staticRedio900 = "rgba(102, 0, 26, 1)";
var staticRedio700 = "rgba(235, 0, 59, 1)";
var staticRedio500 = "rgba(255, 51, 102, 1)";
var staticRedio300 = "rgba(255, 153, 179, 1)";
var staticRedio100 = "rgba(255, 245, 248, 1)";
var staticDarkBase900 = "rgba(255, 255, 255, 1)";
var staticDarkBase800 = "rgba(247, 248, 248, 1)";
var staticDarkBase700 = "rgba(230, 233, 234, 1)";
var staticDarkBase600 = "rgba(190, 196, 198, 1)";
var staticDarkBase500 = "rgba(149, 160, 163, 1)";
var staticDarkBase400 = "rgba(106, 124, 129, 1)";
var staticDarkBase300 = "rgba(63, 88, 95, 1)";
var staticDarkBase200 = "rgba(24, 50, 57, 1)";
var staticDarkBase100 = "rgba(5, 37, 46, 1)";
var staticDarkBase0 = "rgba(0, 28, 36, 1)";
var staticBase900 = "rgba(0, 28, 36, 1)";
var staticBase800 = "rgba(5, 37, 46, 1)";
var staticBase700 = "rgba(24, 50, 57, 1)";
var staticBase600 = "rgba(63, 88, 95, 1)";
var staticBase500 = "rgba(106, 124, 129, 1)";
var staticBase400 = "rgba(149, 160, 163, 1)";
var staticBase300 = "rgba(190, 196, 198, 1)";
var staticBase200 = "rgba(230, 233, 234, 1)";
var staticBase100 = "rgba(247, 248, 248, 1)";
var staticBase0 = "rgba(255, 255, 255, 1)";
var lightThemeColors = {
	positive700: positive700,
	positive500: positive500,
	positive300: positive300,
	positive100: positive100,
	notice900: notice900,
	notice700: notice700,
	notice300: notice300,
	notice100: notice100,
	negative700: negative700,
	negative300: negative300,
	negative100: negative100,
	informative700: informative700,
	informative100: informative100,
	maybeBlue900: maybeBlue900,
	maybeBlue700: maybeBlue700,
	maybeBlue500: maybeBlue500,
	maybeBlue300: maybeBlue300,
	maybeBlue100: maybeBlue100,
	yellove900: yellove900,
	yellove700: yellove700,
	yellove500: yellove500,
	yellove300: yellove300,
	yellove100: yellove100,
	redio900: redio900,
	redio700: redio700,
	redio500: redio500,
	redio300: redio300,
	redio100: redio100,
	base900: base900,
	base800: base800,
	base700: base700,
	base600: base600,
	base500: base500,
	base400: base400,
	base300: base300,
	base200: base200,
	base100: base100,
	base0: base0,
	staticDarkPositive700: staticDarkPositive700,
	staticDarkPositive500: staticDarkPositive500,
	staticDarkPositive300: staticDarkPositive300,
	staticDarkPositive100: staticDarkPositive100,
	staticDarkNotice900: staticDarkNotice900,
	staticDarkNotice700: staticDarkNotice700,
	staticDarkNotice300: staticDarkNotice300,
	staticDarkNotice100: staticDarkNotice100,
	staticDarkNegative700: staticDarkNegative700,
	staticDarkNegative300: staticDarkNegative300,
	staticDarkNegative100: staticDarkNegative100,
	staticDarkInformative700: staticDarkInformative700,
	staticDarkInformative100: staticDarkInformative100,
	staticPositive700: staticPositive700,
	staticPositive500: staticPositive500,
	staticPositive300: staticPositive300,
	staticPositive100: staticPositive100,
	staticNotice900: staticNotice900,
	staticNotice700: staticNotice700,
	staticNotice300: staticNotice300,
	staticNotice100: staticNotice100,
	staticNegative700: staticNegative700,
	staticNegative300: staticNegative300,
	staticNegative100: staticNegative100,
	staticInformative700: staticInformative700,
	staticInformative100: staticInformative100,
	staticDarkMaybeBlue900: staticDarkMaybeBlue900,
	staticDarkMaybeBlue700: staticDarkMaybeBlue700,
	staticDarkMaybeBlue500: staticDarkMaybeBlue500,
	staticDarkMaybeBlue300: staticDarkMaybeBlue300,
	staticDarkMaybeBlue100: staticDarkMaybeBlue100,
	staticDarkYellove900: staticDarkYellove900,
	staticDarkYellove700: staticDarkYellove700,
	staticDarkYellove500: staticDarkYellove500,
	staticDarkYellove300: staticDarkYellove300,
	staticDarkYellove100: staticDarkYellove100,
	staticDarkRedio900: staticDarkRedio900,
	staticDarkRedio700: staticDarkRedio700,
	staticDarkRedio500: staticDarkRedio500,
	staticDarkRedio300: staticDarkRedio300,
	staticDarkRedio100: staticDarkRedio100,
	staticMaybeBlue900: staticMaybeBlue900,
	staticMaybeBlue700: staticMaybeBlue700,
	staticMaybeBlue500: staticMaybeBlue500,
	staticMaybeBlue300: staticMaybeBlue300,
	staticMaybeBlue100: staticMaybeBlue100,
	staticYellove900: staticYellove900,
	staticYellove700: staticYellove700,
	staticYellove500: staticYellove500,
	staticYellove300: staticYellove300,
	staticYellove100: staticYellove100,
	staticRedio900: staticRedio900,
	staticRedio700: staticRedio700,
	staticRedio500: staticRedio500,
	staticRedio300: staticRedio300,
	staticRedio100: staticRedio100,
	staticDarkBase900: staticDarkBase900,
	staticDarkBase800: staticDarkBase800,
	staticDarkBase700: staticDarkBase700,
	staticDarkBase600: staticDarkBase600,
	staticDarkBase500: staticDarkBase500,
	staticDarkBase400: staticDarkBase400,
	staticDarkBase300: staticDarkBase300,
	staticDarkBase200: staticDarkBase200,
	staticDarkBase100: staticDarkBase100,
	staticDarkBase0: staticDarkBase0,
	staticBase900: staticBase900,
	staticBase800: staticBase800,
	staticBase700: staticBase700,
	staticBase600: staticBase600,
	staticBase500: staticBase500,
	staticBase400: staticBase400,
	staticBase300: staticBase300,
	staticBase200: staticBase200,
	staticBase100: staticBase100,
	staticBase0: staticBase0
};

exports.base200 = base200;
exports.base600 = base600;
exports.lightThemeColors = lightThemeColors;
exports.staticBase0 = staticBase0;
exports.staticBase800 = staticBase800;
exports.staticMaybeBlue700 = staticMaybeBlue700;
exports.staticPositive700 = staticPositive700;
exports.staticRedio700 = staticRedio700;
exports.staticYellove500 = staticYellove500;
//# sourceMappingURL=light-theme-colors-bb1a2999.js.map
